const part = [
    {
        path: 'bank-record-cmbAndCCBC-list',
        name: 'bank-record-cmbAndCCBC-list',
        meta: {
            icon: 'md-stats',
            title: '会员招行建行充值记录',
            notCache: true,
            access: ['S', 'I', 'I2'],
            items: [
            ]
        },
        component: () => import('@/view/finance-management/bank-record/bank-record-cmbAndCCBC-list')
    }
];

export default part;
